import { getTeamsDateFormat, getTeamsTimeFormat } from "../utils/dateUtils";

const pl = {
    common: {
        loader: "Načítání dat...",
        meetingCancelled: "Schůzka byla zrušena",
    },
    logo: {
        corporation: "Logo mBank pro velkoobchodní klienty",
        retail: "Logo mBank pro maloobchodní klienty",
        private: "Logo mBank pro soukromé bankovnictví",
    },
    requestCancelMeeting: {
        actionButton: "Pošlete svůj požadavek",
        pendingDescription: (startAt: Date) =>
            `Chcete poslat pořadateli požadavek na zrušení schůzky
            dne ${getTeamsDateFormat(startAt)} v čase ${getTeamsTimeFormat(startAt)}?`,
        inProgressDescription: (startAt: Date) =>
            `Schůzka ${getTeamsDateFormat(startAt)} v čase ${getTeamsTimeFormat(startAt)} už probíhá nebo hned začne.
            Její zrušení už není možné. V případě nutnosti odvolat schůzku se spojte se svým poradcem.`,
        expiredDescription: (endAt: Date) =>
            `Schůzka skončila ${getTeamsDateFormat(endAt)} v čase ${getTeamsTimeFormat(
                endAt
            )}.\nZrušení už není možné.`,
        requestSent:
            "Požadavek na zrušení schůzky už byl odeslán. Váš poradce se s vámi brzy spojí za účelem potvrzení zrušení.",
        redirectButton: "Neodesílat",
    },
    joinMeeting: {
        meetingNotFound:
            "Schůzka nebyla nalezena. Odkaz může být nesprávný. Zkontrolujte jeho správnost a zkuste to znovu.",
        actionButton: "Zahajte schůzku",
        redirectButton: "Zrušit schůzku",
        pendingDescription: (startAt: Date) =>
            `Setkání bude zahájeno ${getTeamsDateFormat(startAt)} v čase ${getTeamsTimeFormat(
                startAt
            )}.\nPřipojit se můžete 10 minut před zahájením.`,
        inProgressDescription:
            "Za chvíli začne setkání, které bude nahráváno.\nPokud s tím nesouhlasíte, stiskněte na tlačítko Zrušit schůzku",
        expiredDescription: (endAt: Date) =>
            `Schůzka skončila ${getTeamsDateFormat(endAt)} v čase ${getTeamsTimeFormat(
                endAt
            )}.\nPřipojení už není možné.`,
        wrongAddress:
            "Adresa schůzky je neplatná. Zkontrolujte, jestli adresa v prohlížeči je stejná jako ta, kterou jste obdrželi v e-mailové zprávě.",
        failedToJoin:
            "Nepodařilo se připojit ke schůzce. Odkaz může být nesprávný. Zkontrolujte jeho správnost a zkuste to znovu.",
        browserUnsupportedError: (recommendedBrowsers: string) =>
            `Používáte prohlížeč, který není podporován. Doporučuejeme používat nejnovější verzi jednoho z těchto prohlížečů ${recommendedBrowsers}`,
    },
};

export default pl;
